"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterGroup = exports.FilterButton = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var screenSizes_1 = require("../../screenSizes");
var theme_1 = require("../../theme");
var Select_1 = require("../Select");
/**
 * The filter button variant, used for filtering. Similar to the select button, but more flexible sizing
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/Button.html}
 * @see {@link https://compass.circleci.com/?path=/story/rac-buttons-filterbutton--default}
 *
 * @example
 * ```tsx
 * <FilterButton>
 *   <Flex gap="space4" alignItems="center">
 *     <ProjectOutlineIcon size={20} />
 *     <SelectValue />
 *   </Flex>
 *   <ArrowDropDownIcon size={16} aria-hidden={true} />
 * </FilterButton>
 * ```
 *
 * @param children - The content to display inside the button
 * @param isDisabled - Whether the button is disabled. Defaults to false
 * @param type - The behavior of the button when used in an HTML form. Defaults to 'button'
 * @param onPress - Handler that is called when the press is released over the target
 * @param onPressStart - Handler that is called when a press interaction starts
 * @param onPressEnd - Handler that is called when a press interaction ends
 * @param onPressChange - Handler that is called when the press state changes
 * @param onPressUp - Handler that is called when a press is released over the target
 * @param onKeyDown - Handler that is called when a key is pressed
 * @param onKeyUp - Handler that is called when a key is released
 * @param onKeyPress - Handler that is called when a key is pressed
 * @param onFocus - Handler that is called when the button receives focus
 * @param onBlur - Handler that is called when the button loses focus
 * @param onFocusChange - Handler that is called when the focus state changes
 * @param autoFocus - Whether the button should receive focus on render. Defaults to false
 * @param onHoverStart - Handler that is called when a hover interaction starts
 * @param onHoverEnd - Handler that is called when a hover interaction ends
 * @param onHoverChange - Handler that is called when the hover state changes
 */
exports.FilterButton = (0, styled_1.default)(Select_1.SelectButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-width: 0;\n  gap: ", ";\n  justify-content: flex-start;\n  font-size: ", ";\n\n  @media (max-width: ", ") {\n    max-width: 100%;\n    gap: ", ";\n    justify-content: space-between;\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    max-width: 180px;\n  }\n\n  @media (min-width: ", ") {\n    max-width: 300px;\n  }\n"], ["\n  min-width: 0;\n  gap: ", ";\n  justify-content: flex-start;\n  font-size: ", ";\n\n  @media (max-width: ", ") {\n    max-width: 100%;\n    gap: ", ";\n    justify-content: space-between;\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    max-width: 180px;\n  }\n\n  @media (min-width: ", ") {\n    max-width: 300px;\n  }\n"])), theme_1.theme.space.space12, theme_1.theme.fontSizes.small, screenSizes_1.screenSizes.small, theme_1.theme.space.space8, screenSizes_1.screenSizes.small, screenSizes_1.screenSizes.wide, screenSizes_1.screenSizes.wide);
exports.FilterGroup = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  gap: ", ";\n  flex-wrap: wrap;\n\n  @media (max-width: ", ") {\n    flex-direction: column;\n    width: 100%;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  gap: ", ";\n  flex-wrap: wrap;\n\n  @media (max-width: ", ") {\n    flex-direction: column;\n    width: 100%;\n  }\n"])), theme_1.theme.space.space8, screenSizes_1.screenSizes.small);
var templateObject_1, templateObject_2;
//# sourceMappingURL=FilterGroup.js.map